import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 5.25L4.25 8.75L11.25 1.25",
		stroke: "#0A0A0A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckIcon;
